import { RequiredQueryKeyFilter, createDefaultQueryKeysGenerator } from 'core/query/constants';

interface CohortQueryDetailKeyFilter extends RequiredQueryKeyFilter {
  cohortId: number;
}

type CohortQueryListKeyFilter = RequiredQueryKeyFilter;

export const cohortQueryKeys = createDefaultQueryKeysGenerator<
  CohortQueryListKeyFilter,
  CohortQueryDetailKeyFilter
>({
  keyDataType: 'cohorts',
});
